/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewTorrent } from './CRSFSecReviewTorrent';
import {
    CRSFSecReviewTorrentFromJSON,
    CRSFSecReviewTorrentFromJSONTyped,
    CRSFSecReviewTorrentToJSON,
} from './CRSFSecReviewTorrent';

/**
 * 
 * @export
 * @interface CRSFSecReviewTorrentsPagedResponse
 */
export interface CRSFSecReviewTorrentsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTorrentsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTorrentsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewTorrent>}
     * @memberof CRSFSecReviewTorrentsPagedResponse
     */
    results?: Array<CRSFSecReviewTorrent>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewTorrentsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewTorrentsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewTorrentsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewTorrentsPagedResponseFromJSON(json: any): CRSFSecReviewTorrentsPagedResponse {
    return CRSFSecReviewTorrentsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewTorrentsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTorrentsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewTorrentFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewTorrentsPagedResponseToJSON(value?: CRSFSecReviewTorrentsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewTorrentToJSON)),
        'total': value.total,
    };
}

